import store from "../../../store";
import foodora_export from './foodora_export.vue';

window.foodora_export =  new Vue({
    store,
    el: 'div#foodora_export',

    name : "foodora_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        foodora_export,
    }
});
